/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { useAcessoLotacaoOrEstagio } from 'components/auth/useAcessoLotacao'
import { Breadcrumb } from 'components/breadcrumb'
import { PageContent } from 'components/layout/PageContent'
import { getLotacaoResponsavel } from 'components/lotacao-responsavel/utils/utils-lotacaoResponsavel'
import { TitleGroup } from 'components/TitleGroup'
import { Maybe } from 'graphql/types.generated'
import { Fragment, useMemo } from 'react'

import { useAtividadeColetivaCache } from '../hooks/useAtividadeColetivaCache'
import { AtividadeColetivaFormModel } from '../model-atividadeColetiva'
import AtividadeColetivaReuniaoForm from './AtividadeColetivaReuniaoForm'

export const AtividadeColetivaRegistrarReuniaoView = () => {
  const { acesso, profissional } = useAcessoLotacaoOrEstagio()
  const { cachedValue, setCachedValue, clearCachedValue } = useAtividadeColetivaCache()

  const atividadeColetivaDefaultForm = useMemo<AtividadeColetivaFormModel>(
    () =>
      ({
        lotacaoResponsavel: getLotacaoResponsavel(
          profissional,
          acesso.cbo,
          acesso.equipe,
          acesso.unidadeSaude,
          acesso.id,
          acesso.__typename
        ),
      } as Maybe<AtividadeColetivaFormModel>),
    [acesso.__typename, acesso.cbo, acesso.equipe, acesso.id, acesso.unidadeSaude, profissional]
  )

  return (
    <Fragment>
      <Breadcrumb title='Registro de reunião de equipe' />
      <PageContent type='filled' style={styles.pageContent}>
        <TitleGroup title='Registro de reunião' style={styles.header} />
        <AtividadeColetivaReuniaoForm
          initialValues={atividadeColetivaDefaultForm}
          initialDirtyFields={cachedValue}
          setCachedValue={setCachedValue}
          clearCachedValue={clearCachedValue}
        />
      </PageContent>
    </Fragment>
  )
}

const styles = {
  header: css`
    margin-top: 1rem;
    margin-bottom: 2rem;
  `,
  pageContent: css`
    padding-bottom: 3.5rem;
  `,
}
